import { useState } from 'react';

import { Stack } from '@mui/material';

import StepScreen from '@/karehero-app/access/StepScreen';
import { type Account } from '@/karehero-app/access/AccountBar';
import OptionCard from '@/components/wrapped/OptionCard';
import { FORK_QUESTION } from '@/karehero-app/onboarding/Onboarding.content';
import { INTAKE_FORK_OPTIONS } from '@/karehero-app/tell-us-once/intake/content';

// Option 1, screen 2. A copy of the onboarding fork rather than a mount of it,
// so this flow can change the question, the answers or the rhythm without
// moving the master prototype's onboarding. No step counter: the person is not
// on that seven-step journey here.
const ForkScreen = ({
  onNext,
  onBack,
  account,
}: {
  onNext: () => void;
  onBack?: () => void;
  /** The app bar. See StepScreen's own `account`. */
  account?: Account;
}) => {
  const [picked, setPicked] = useState<string | null>(null);

  return (
    <StepScreen
      account={account}
      title={FORK_QUESTION}
      primaryLabel='Next'
      onPrimary={onNext}
      isPrimaryDisabled={!picked}
      onBack={onBack}
    >
      <Stack spacing={1.5}>
        {INTAKE_FORK_OPTIONS.map((o) => (
          <OptionCard
            key={o.label}
            control='radio'
            selected={picked === o.label}
            label={o.label}
            onClick={() => setPicked(o.label)}
          />
        ))}
      </Stack>
    </StepScreen>
  );
};

export default ForkScreen;
